import { render, staticRenderFns } from "./property-by-search.vue?vue&type=template&id=bb7284da&"
import script from "./property-by-search.vue?vue&type=script&lang=js&"
export * from "./property-by-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports